import { useEffect, useState } from "react";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { _BudgetRPFactory, _RemoteAbstractAction, _single } from "../../../../../../../core/services/dataBean/EntityCatalog";
import { BasicTable, MASK_MONEY } from "../../../../../../theme/Component/BasicTable";
import { ListMenu } from "../../../../../../theme/Component/ListMenu";
import { Modal } from "../../../../../../theme/Component/Modal";
import { InputMoney } from "../../../../../../theme/Input/InputMoney";
import { BasicButton } from "../../../../../../theme/Component/BasicButton";

interface Props {
    idApplicationInvoker: number,
    properties: any;
    data: any;
    setData: any;
    lastStep: boolean;
}
export const OBAdjustmentAction = ({ idApplicationInvoker, properties, lastStep, data, setData }: Props) => {

    const { lista, setLista, bean, setBean } = useDataBean(_RemoteAbstractAction);
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [prevBean, setPrevBean] = useState<any>(null);

    const head = [
        { title: 'Rubro Presupuestal', property: 'BudgetName', visible: true },
        { title: 'Saldo del Rubro', property: 'LeftValue', visible: true, mask: MASK_MONEY },
        { title: 'Valor de la Apropiación', property: 'Value', visible: true, mask: MASK_MONEY },
        { title: 'Presupuesto', property: 'BudgetTypeName', visible: true },
        { title: 'Recurso Presupuestal', property: 'BudgetResourceName', visible: true },
        { title: 'Fuente de Financiamiento', property: 'BudgetSourceName', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
    ]

    useEffect(() => {
        if (data.BudgetList.DefaultValue) {
            setLista(data.BudgetList.DefaultValue)
        }
    }, [data.BudgetList])

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: data.BudgetList.Editable, evento: () => { setModal({ ...modal, "view": true, "name": `Editar Rubro ${bean.BudgetIDName ?? ""}` }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const updateItem = () => {

        const updatedLista = lista.filter((item: any) =>
            JSON.stringify(item.DataBeanProperties) !== JSON.stringify(prevBean)
        );

        let temp = [...updatedLista, {
            DataBeanProperties: bean,
            DataBeanName: 'budget.Budget'
        }];
        setLista(temp);
        setBean({});
        setPrevBean({});
        setModal({ ...modal, "view": false })
    }


    const setRowBean = (e) => {
        console.log(e)
        setBean(e);
        setPrevBean(e);
    };

    const submitForm = () => {

        let key = Object.keys(data);
        console.log({ [key[0]]: lista });

        if (setData) {
            setData({ [key[0]]: lista });
        }
    }


    return (
        <div className="row">
            <div className="col-md-12">
                <label>{data.BudgetList.Name}</label>
            </div>
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={setRowBean} listButtons={listaBotones()} />
            </div>

            <div className="col-md-12">
                <BasicButton icon="ri-send-plane-2-line" clase="primary" eventClick={submitForm}>Guardar</BasicButton>
            </div>

            <div className="col-md-12">
                <Modal modal={modal} updateModal={setModal} eventModal={updateItem}>
                    <div className="row">
                        <div className="col-md-12">
                            <InputMoney _label="Valor a Obligar" _value={bean.Value} onChange={(e) => { setBean({ ...bean, "Value": e }) }} />
                        </div>
                        <div className="col-md-12">
                            <label>Observaciones</label>
                            <textarea className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, "Description": e.target.value }) }} />
                        </div>
                    </div>
                </Modal>
            </div>
        </div>
    )
}